// extracted by mini-css-extract-plugin
export var active = "Menu-module--active--edDvb";
export var menuContainer = "Menu-module--menuContainer--cgEGF";
export var menuIcon = "Menu-module--menuIcon--TXljq";
export var root = "Menu-module--root--yjw67";
export var styledMenu = "Menu-module--styledMenu--imlJO";